import React, { useState } from "react";
import emailjs from "emailjs-com";
import "../../App.css";

const ContactForm = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [messageSent, setMessageSent] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!name || !email || !message) {
      // Handle form validation errors
      return;
    }

    // Send the email using EmailJS
    emailjs
      .send(
        "service_pldpx46",
        "template_y6tkzfb",
        {
          from_name: name,
          from_email: email,
          message: message,
        },
        "YEi_mA_AKDAwNElnp",
      )
      .then(
        (response) => {
          console.log("Email sent:", response);
          // Handle success, show a success message
          setMessageSent(true);
          // Set a timeout to make the message disappear after 10 seconds
          setTimeout(() => {
            setMessageSent(false);
          }, 20000); // 10 seconds (10000 milliseconds)
        },
        (error) => {
          console.error("Error sending email:", error);
          // Handle error, show an error message
          setMessageSent(false);
        },
      );

    // Clear the form fields
    setName("");
    setEmail("");
    setMessage("");
  };

  return (
    <div className="pageContent">
      <div className="contactBlock">
        <h3>CONTACT</h3>
        <div className="about-wrapper">
          <div className="home-itemT">
            <form onSubmit={handleSubmit}>
              <div className="contact-contentT">
                <div className="contactForm">
                  <div className="contactName">
                    <input
                      className="nameInput"
                      type="text"
                      id="name"
                      name="name"
                      placeholder="Name"
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                      required
                    />
                  </div>
                  <div className="contactName">
                    <input
                      className="nameInput"
                      type="email"
                      id="email"
                      name="email"
                      placeholder="E-mail"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                    />
                  </div>

                  <button type="submit" className="sendButton">
                    Send
                  </button>
                </div>
                <div className="contactText">
                  <textarea
                    className="textInput"
                    id="message"
                    name="message"
                    placeholder="Message"
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                    required
                  ></textarea>
                </div>
              </div>
            </form>
          </div>
        </div>
        <div className="some1">
          {messageSent && (
            <div className="success-message">
              Message sent! Thanks for contacting!
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ContactForm;
